import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from './core/modules/auth/services/auth.service';
import { LoaderService } from './shared/services/loader.service';
import { Observable } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [RouterOutlet, CommonModule, MatProgressSpinnerModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  hasNav = true;
  isLoading!: Observable<boolean>;
  public throwTestError(): void {
    throw new Error('Sentry Test Error');
  }
  constructor(
    private readonly loaderService: LoaderService,
    private readonly translate: TranslateService
  ) {
    this.isLoading = this.loaderService.isLoading$;

    // Set up available languages
    this.translate.addLangs(['en', 'ar', 'zh']);
    this.translate.setDefaultLang('en');

    // Get saved language or use Arabic as default
    const savedLang = localStorage.getItem('lang');
    const langToUse = savedLang || 'en';

    // Use the language
    this.translate.use(langToUse);
    localStorage.setItem('lang', langToUse);

    // Set HTML dir and lang attributes for RTL support
    this.setLanguageDirection(langToUse);
  }

  private setLanguageDirection(lang: string): void {
    const htmlTag = document.getElementsByTagName('html')[0];
    if (lang === 'ar') {
      htmlTag.setAttribute('dir', 'rtl');
      htmlTag.setAttribute('lang', 'ar');
      localStorage.setItem('dir', 'rtl');
    } else {
      htmlTag.setAttribute('dir', 'ltr');
      htmlTag.setAttribute('lang', lang);
      localStorage.setItem('dir', 'ltr');
    }
  }

  ngOnInit(): void { }
}
